import { Grid } from '@mui/material'
import { AppBox, AppTypography, AppTable, SimpleCheckBox, SimpleSwitch } from 'components'
import { SubAccountStatus } from 'globals/constants'
import { FC } from 'react'
import { SubAccountViewModel } from 'sdk'

interface Props {
  subAccount: SubAccountViewModel
  onAccessChange: (status: SubAccountStatus) => void
}

export const RemoveSubAccountStepThreeConfirmation: FC<Props> = ({ subAccount, onAccessChange }) => {
  return (
    <AppBox display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'100%'} gap={2}>
      <AppBox paddingBottom={2} paddingX={10}>
        <AppTypography fontWeight={'bold'} fontSize={32} textAlign={'center'}>
          Your user has been scheduled for removal from your subscription plan
        </AppTypography>
      </AppBox>
      <Grid container>
        <Grid item xs={8}>
          <AppTypography fontWeight={600} fontSize={16}>
            Account Access
          </AppTypography>
          <AppTypography>
            Your user is successfully scheduled for removal at the end of your current billing cycle. Until then this
            user will continue to have access to their account.
            <br />
            <br />
            Alternatively you can choose to disable their account access using the option below. Disabling their account
            access will prevent them from being able to log in.
          </AppTypography>
          <AppBox paddingTop={2}>
            <AppTypography fontWeight={'bold'}>Account Access</AppTypography>
            <AppBox display={'flex'} gap={1} alignItems={'center'}>
              <AppTypography>Disabled</AppTypography>
              <SimpleSwitch
                defaultChecked={subAccount?.Status === SubAccountStatus.Enabled}
                size="medium"
                disabled={subAccount?.Status === SubAccountStatus.Pending}
                onChange={(event) => {
                  let _status = event.target.checked ? SubAccountStatus.Enabled : SubAccountStatus.Disabled
                  onAccessChange(_status)
                }}
              />
              <AppTypography>Enabled</AppTypography>
            </AppBox>
          </AppBox>
        </Grid>
        <Grid item xs={4} textAlign={'right'}>
          <img src="/images/pax/Confirmation.png" alt="img" />
        </Grid>
      </Grid>
    </AppBox>
  )
}
